import React, { useEffect, useState } from 'react'
import { Close, KeyboardArrowDown, LogoutOutlined, Menu } from '@mui/icons-material'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { userProfile, logout } from '../../store/features/user/userSlice'

const Header = () => {
  const [isClick, setIsClick] = useState(false)
  const [subMenuOpen, setSubMenuOpen] = useState(false)
  const dispatch = useDispatch()
  const { user } = useSelector((store) => store.auth)
  const token = localStorage.getItem("token")
  const location = useLocation()

  const toggleNavbar = () => {
    setIsClick(!isClick)
  }

  useEffect(() => {
    if (token) {
      dispatch(userProfile(token))
    }
  },[token, token])

  const handleLogout = () => {
    dispatch(logout())
  }

  return (
    <header className='bg-blue-950 fixed z-20 top-0 px-8 py-5 mx-auto w-full max-w-[1024px] rounded-b-3xl'>
    {/* <header className='border border-white/20 bg-white/10 shadow-lg backdrop-filter backdrop-blur-[10px] fixed z-20 top-0 px-8 py-5 mx-auto w-full max-w-[1024px] rounded-b-3xl'> */}
      <nav className=''>
        <div className='flex justify-between items-center'>
          <Link to="/">
            <Typography
              sx={{
                color: '#fff',
                fontSize: '35px',
                fontWeight: 'bold'
              }}
            >
              MACRUM
            </Typography>
          </Link>
          <div className='hidden md:block text-xl'>
            <ul className='flex space-x-8 font-medium'>
              <li className='group'>
                <div className='text-white cursor-pointer'>
                  Products
                  <KeyboardArrowDown className='group-hover:rotate-180 duration-200' />
                </div>
                <div className='absolute top-24 bg-blue-950 p-4 rounded-xl w-[25rem] hidden group-hover:block'>
                  <div className='absolute w-16 h-10 -top-10 left-5 bg-transparent' />
                  <div>
                    <div>
                      <Link to="/pos-billing-software">
                        <h6 className='text-white opacity-80'>MACRUM POS Billing Software</h6>
                        <p className='text-white opacity-80 text-sm'>Fast and Powerful User Friendly Business Management Software</p>
                      </Link>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <NavLink to="/support" className='text-white'>
                  Support
                </NavLink>
              </li>
              <li>
                <NavLink to="/buy-macrum" className='text-white'>
                  Buy Now
                </NavLink>
              </li>
              <li>
                <NavLink to="/download" className='text-white'>
                  Download
                </NavLink>
              </li>
            </ul>
          </div>
          <div>
            <Link to='tel:+91 8900689991' className='hidden md:block text-white'>Contact Us : +91 8900689991</Link>
            <button 
              className='md:hidden text-white'
              onClick={toggleNavbar}
            >
              {isClick ? (
                <Close />
              ) : (
                <Menu />
              )}
            </button>
          </div>
        </div>
        {isClick && (
          <div className='md:hidden'>
            <hr className='border-slate-700' />
            <div className='px-2 pt-2 pb-3 space-y-1 sm:px-3'>
              <ul className='space-y-2'>
                <Link to='tel:+91 8900689991' className='text-white'>Contact Us : +91 8900689991</Link>
                  <hr className='border-slate-700' />
                <li className='group'>
                  <div
                    onClick={() => setSubMenuOpen(!subMenuOpen)}
                    className='text-white font-bold text-lg cursor-pointer'
                  >
                    Products
                    <KeyboardArrowDown className={`${subMenuOpen && 'rotate-180'} duration-200`} />
                  </div>
                  {subMenuOpen && (
                    <div className=''>
                      <div>
                        <div>
                          <Link to="/pos-billing-software">
                            <h6 className='text-white opacity-80 font-semibold'>MACRUM POS Billing Software</h6>
                            <p className='text-white opacity-80 text-sm'>Fast and Powerful User Friendly Business Management Software</p>
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                </li>
                <hr className='border-slate-700' />
                <li>
                  <NavLink
                    to="/support"
                    className='text-white font-bold text-lg'
                  >
                    Support
                  </NavLink>
                </li>
                <hr className='border-slate-700' />
                <li>
                  <NavLink
                    to="/buy-macrum"
                    className='text-white font-bold text-lg'
                  >
                    Buy Now
                  </NavLink>
                </li>
                <hr className='border-slate-700' />
                <li>
                  <NavLink
                    to="/download"
                    className='text-white font-bold text-lg'
                  >
                    Download
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        )}
      </nav>
    </header>
  )
}

export default Header
